import { uiText } from '../../i18n/uiText';
import React from 'react';

/**
 * Shared loading state.  Its visuals live in the main design system instead
 * of a second, outdated set of JavaScript color tokens.
 */

export function LoadingState({ message = uiText("Загрузка…"), minHeight = 200 }) {
  return (
    <div className="loading-center" style={{ minHeight }} role="status" aria-live="polite">
      <div className="spinner" aria-hidden="true" />
      <div>{message}</div>
    </div>
  );
}
